import { collections, sources } from './illustrationsList';

export const gradientMaker = {
  key: 'typedream_gradients__maker',
  title: 'Open Gradient Maker',
  keywords: ['gradient', 'background', 'blue', 'green', 'red'],
  category: ['gradient', 'background'],
  collection: collections.typedream_gradients,
  source: sources.typedream,
  previewURL:
    'https://typedream.sfo3.digitaloceanspaces.com/illustrations/gradients/gradient-maker.png',
  downloadURL: '/gradient',
  action: 'download',
};
